import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-mapped-item-popup',
  templateUrl: './mapped-item-popup.component.html',
  styleUrl: './mapped-item-popup.component.scss'
})
export class MappedItemPopupComponent implements OnInit, OnDestroy {
  actions:any;
  private destroy$ = new Subject<void>();
  skusNotMapped:any[]=[]

  constructor(
  @Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<MappedItemPopupComponent>) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
     this.actions = this.data.actions || [
      { text: "Close" },
    ];
    this.data.skusNotMapped.forEach((ele)=>{
      if(ele){
        ele.asin=ele.asin;
        ele.fnsku=ele.fnsku;
        ele.imageUrl=ele.image;
        ele.qty=ele.pickingQty;
        ele.sku=ele.sku;
        ele.title=ele.title;
      }
    })
    this.skusNotMapped=this.data.skusNotMapped
  }

  action(e?) {
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();
  }

}
